import { cn } from "@/lib/utils";
import { TONE_STYLES } from "@/lib/colors";

// Marqueur « Avance » : voir shared/advance.ts pour la règle métier.
// Vente comptée comme effectuée avant la fin du délai de rétractation → provisoire.
export function AvanceTag({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        "pill",
        TONE_STYLES.yellow.pillBg,
        TONE_STYLES.yellow.pillFg,
        className,
      )}
      title="Vente comptée comme effectuée avant la fin du délai de rétractation (14 j) : provisoire, à rembourser si le client se rétracte."
    >
      Avance
    </span>
  );
}
